var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(!_vm.isEnd)?[_c('span',[_vm._v(_vm._s(_vm.h)+"时")]),_c('span',[_vm._v(_vm._s(_vm.m)+"分")]),_c('span',[_vm._v(_vm._s(_vm.s)+"秒")])]:_c('span',[_vm._v("超时反馈")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }